import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { useAbortedEffect } from "../../../components/hooks";
import { WorkAPI } from "../../../axios/api";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import ModuleTitle from "../../../components/common/title";
import { option_category, option_category_obj } from "../../../service/option";

export default function MemberSettingTarget() {
  const dispatch = useDispatch();
  const redux_user = useSelector((state) => state.user);
  const crumbItem = [
    { key: 1, label: "首頁", href: "/member" },
    { key: 2, label: "系統相關", href: "/member/setting" },
    { key: 3, label: option_category_obj.setting.work.label },
  ];
  const dayArr = ["1", "2", "3", "4", "5", "6", "7"];
  const [apiData, setApiData] = useState([]);

  useAbortedEffect((signal) => {
    dispatch(setProgress(true));

    let params = {
      // memberid: redux_user.userDetail.id
    };

    WorkAPI.getMyPersonalGoalsDatas({
      data: params,
      options: { signal },
    }).then((result) => {
      let { Response, data, message } = result;

      if (Response === 1) {
        let target = [];
        Object.values(data).forEach((item) => {
          dayArr.forEach((day) => {
            if (item?.[`day${day}`] === 1) target.push(`${item.type}_${day}`);
          });
        });
        setApiData(target);
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: message,
            detail: "",
          })
        );
      }

      dispatch(setProgress(false));
    });
  }, []);

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <ModuleTitle data={{ title: option_category_obj.setting.work.label }} />

      <div className="text-xl line-height-4">
        <table className="w-full custom-tb text-center">
          <thead>
            <tr className="bg-blue-50">
              <th>項目</th>
              <th>週一</th>
              <th>週二</th>
              <th>週三</th>
              <th>週四</th>
              <th>週五</th>
              <th>週六</th>
              <th>週日</th>
            </tr>
          </thead>
          <tbody>
            {option_category.record.map((item) => (
              <tr key={`category_${item.type}`}>
                <td className="bg-blue-50">{item.label}</td>
                {dayArr.map((day) => (
                  <td key={`category_${item.type}_${day}`}>
                    {apiData.includes(`${item.type}_${day}`) ? "V" : ""}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
